import { useQuery } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { ActivityResults } from '../services/backendService/types';

function useGameActivityResults(gameId: string) {
  const { data, isFetching } = useQuery({
    queryKey: ['game-results', gameId],
    queryFn: _ => BackendService.instance.game.retrieveResults(gameId),
    staleTime: 1000 * 60 * 60
  });

  return {
    data,
    isLoading: isFetching,
  };
}

export default useGameActivityResults;
